/* eslint-disable complexity */
const get = require("lodash.get");
const $ = require("jquery");
const _ = require("underscore");
const gtm = require("common/analytics/google-tagmanager");
const modalWindow = require("site/mobile/modal-window");
const checkoutChangePage = require("site/mobile/checkout/page-changer");
const showLoginResetRequiredPopup = require("site/mobile/log-in-reset-required");

let $page;
let $popup;
let $password;

const category = "verify_account_modal";
function trackModalShow (network) {
  return gtm.trackEvent({
    category,
    property: category,
    action: "show",
    label: network
  });
}

function trackModalPasswordFocus () {
  return gtm.trackEvent({
    category,
    property: "password_field",
    action: "focus"
  });
}

function trackModalSubmitClick () {
  return gtm.trackEvent({
    category,
    property: "verify_button",
    action: "click"
  });
}

function trackModalCancelClick () {
  return gtm.trackEvent({
    category,
    property: "cancel_button",
    action: "click"
  });
}

function closePopup () {
  $popup.popup("close");
}

function handleRedirection ({ variant }) {
  if (variant === "checkout") {
    var currentUri = window.window.location.href.split("?");
    checkoutChangePage("checkout-page", currentUri[1], {
      allowtransition: true
    });
    return;
  }
  var $formTarget = $page.find("[data-target-uri]");
  if ($formTarget.length) {
    window.location.href = $formTarget.data("targetUri");
    return;
  }
  window.location.href = "/";
}

function login ({ googleIdToken, variant }) {
  var credentials = {
    googleToken: googleIdToken,
    password: $password.val(),
    cookies: true
  };

  $.ajax({
    method: "POST",
    url: "/api/v2/me/login",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(credentials),
    headers: {
      "x-forwarded-host": document.location.host
    },
    success: _.bind(function () {
      handleRedirection({ variant });
    }, this),
    error: _.bind(function (jqXHR) {
      const loginStatus = get(jqXHR, ["responseJSON", "errors", 0, "name"]);
      switch (loginStatus) {
      case "not_authenticated":
        $page.find(".error-verify-password").popup("open");
        break;
      case "locked":
        showLoginResetRequiredPopup(true);
        break;
      case "requires_reset":
        showLoginResetRequiredPopup(false);
        break;
      default:
        $page.find(".error-verify-password").popup("open");
      }
    }, this),
    complete () {
      modalWindow.hide();
    }
  });
}

module.exports = function ({
  googleIdToken,
  pageVariant: variant
} = {}) {
  trackModalShow("google");

  $page = $.mobile.pageContainer.pagecontainer("getActivePage");
  $popup = $("#login-verify-account-popup-checkout-onepage-popup .login-verify-account-popup");

  $password = $popup.find(".password");

  var $form = $popup.find("form");
  var $button = $popup.find(".submit.ui-btn");
  const $text = $form.find("> p");

  $popup.find(".close a").on("click", closePopup);

  $form.find(".close").on("click", trackModalCancelClick);
  $password.on("focus", trackModalPasswordFocus);

  $button.on("click", function () {
    closePopup();
    modalWindow.show();
    trackModalSubmitClick();
    login({
      googleIdToken,
      variant
    });
  });

  const updatedText = $text.text().replace("Facebook", "Google").trim();
  $text.text(updatedText);
  $popup.popup("open");
};
